var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElasticsearchImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0156 63.0325H111.172C118.462 63.0325 124.972 59.6895 129.34 54.4706C120.229 42.6346 105.928 35 89.8359 35C70.1324 35 53.1037 46.4374 45.0156 63.0325Z",
    fill: "#F0BF1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.565 70.8203H42.0122C40.7108 75.2682 40 79.9682 40 84.8364C40 89.7049 40.7108 94.4053 42.0122 98.8528H105.565C113.196 98.8528 119.581 92.6235 119.581 84.8364C119.581 77.0497 113.352 70.8203 105.565 70.8203Z",
    fill: "#07A5DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.51 114.982C125.17 109.88 118.712 106.637 111.483 106.637H45.0156C53.1037 123.232 70.1324 134.669 89.8356 134.669C106.026 134.669 120.408 126.943 129.51 114.982Z",
    fill: "#3EBEB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0122 70.8203C40.7105 75.2682 40 79.9682 40 84.8364C40 89.7049 40.7105 94.4053 42.0122 98.8528H83.6059C84.6962 94.6479 85.3189 89.9759 85.3189 84.8364C85.3189 79.6972 84.6962 75.0252 83.6059 70.8203H42.0122Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7621 41.6953C56.3519 46.6789 49.3439 54.1541 44.9834 63.0313H81.7372C77.9995 54.4656 72.0817 47.302 64.7621 41.6953Z",
    fill: "#D7A229"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3194 128.751C73.4831 122.989 79.2453 115.358 82.8275 106.637H44.9834C49.6554 115.981 57.131 123.768 66.3194 128.751Z",
    fill: "#019B8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElasticsearchImg);
export default __webpack_public_path__ + "static/media/ElasticsearchImg.741d21f41fa402a72a672060312d034f.svg";
export { ForwardRef as ReactComponent };